import { isNone } from '@ember/utils';
import EmailCondition from 'cio/app-models/conditions/email';
import refinement from './refinement';
import { assert } from '@ember/debug';
import { SerializedEmailCondition } from 'cio/types/conditions/condition';
import {
  SerializedLegacyAttributeFilter,
  SerializedLegacyAttributeFilterAnd,
  SerializedLegacyAttributeFilterOr,
} from 'cio/types/conditions/legacy-filter';

export default function (json: SerializedEmailCondition): EmailCondition {
  let event = json.event || {};
  let { filters, name, type } = event;
  let { times, within, inverse, isForeignEvent } = json;
  let email = name;
  let linkHref;

  (
    (filters as SerializedLegacyAttributeFilterAnd)?.and ??
    (filters as SerializedLegacyAttributeFilterOr)?.or ?? [filters as SerializedLegacyAttributeFilter]
  ).forEach((filter) => {
    switch (filter?.field) {
      case 'href':
        linkHref = deserializeSpecificLink(filter);
        break;
      case 'template_id':
        email = `${email}_variation_${filter.value}`;
        break;
    }
  });

  if (isNone(times)) {
    times = 1;
  }

  if (isNone(within)) {
    within = 0;
  }

  if (email.includes('email-campaign')) {
    email = `any_${email}`;
  }

  return EmailCondition.create({
    email,
    inverse,
    linkHref,
    eventType: type,
    refinement: refinement(times, within),
    specificLink: !isNone(linkHref),
    isForeignEvent: isForeignEvent === true,
  });
}

// Specific link filter looks like this:
//
// {
//   "field":"href",
//   "operator":"contains",
//   "value":"http://example.com",
//   "inverse":false,
// }
//
// If the filter matches, return `value`; otherwise return undefined.
function deserializeSpecificLink(filter: SerializedLegacyAttributeFilter) {
  if (isNone(filter)) {
    return;
  }

  if (Object.keys(filter).length === 0) {
    return;
  }

  let { field, operator, value, inverse } = filter;

  assert(`Invalid event filter object: ${JSON.stringify(filter)}`, ![field, operator, value, inverse].some(isNone));

  if (field === 'href' && operator === 'contains' && inverse === false) {
    return value;
  }

  return;
}
